import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import Fab from '@mui/material/Fab';
import Tooltip from '@mui/material/Tooltip';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Paper, Container } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const FloatingbackButton = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(-1);
   // navigate('/Project/Add'); // or your desired route
  };

  return (
    <Tooltip 
    title = {<Typography sx={{ fontSize: '1rem', fontWeight: 'bold' }}>
      go back
    </Typography>}
    >
      <Fab
        color="primary"
        aria-label="back"
         size="small" 
        onClick={handleClick}
        sx={{
          position: 'fixed',
           top: 75,
           left: 'calc(100% - 120px)', 
          zIndex: 1000,
           backgroundColor: '#2a366e',  
          '&:hover': {
            backgroundColor: '#4519e6ff',  
          },
        }}
      >
        <ArrowBackIcon sx={{ fontSize: 25 }}/>
      </Fab>

    </Tooltip>
  );
};

export default FloatingbackButton;
